import type { AutomationJobResourceAIOutputResponse } from '@repo/api-codegen';
import type { IBaseModel } from '@repo/common/models/baseModel.ts';
import { useMemo } from 'react';
import type { ExtendedDataTableColumn } from '../../TableV2/types';
import {
	AutomationEntityAiOutputRender,
	AutomationEntityRender,
} from './render';

export const useAiGeneratedResourceColumns = (): ExtendedDataTableColumn<
	AutomationJobResourceAIOutputResponse & IBaseModel
>[] => {
	const columns: ExtendedDataTableColumn<
		AutomationJobResourceAIOutputResponse & IBaseModel
	>[] = useMemo(
		() => [
			{
				titleLabel: 'Resources',
				accessor: 'entity',
				render: (
					record: AutomationJobResourceAIOutputResponse & IBaseModel
				) => <AutomationEntityRender entity={record.entity} />,
			},
			{
				titleLabel: 'AI output',
				accessor: 'ai_output',
				render: (
					record: AutomationJobResourceAIOutputResponse & IBaseModel
				) => <AutomationEntityAiOutputRender aiUpdate={record.ai_output} />,
			},
		],
		[]
	);

	return columns;
};
